import * as z from 'zod'
import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import { useGTMFetchErrorHandling } from './useGTMFetchErrorHandling'
import { GTM_API_LINK, gtmFetcher, gtmSWRErrorHandler } from 'lib/gtm'

const schema = z.object({
	workspaceChange: z.array(z.object({})).optional(),
	mergeConflict: z.array(z.object({})).optional(),
})

type StatusData = z.infer<typeof schema>

export function useGTMWorkspaceStatus(
	accountId: string | null,
	containerId: string | null,
	workspaceId: string | null,
	options?: SWRConfiguration,
) {
	const shouldFetch = Boolean(accountId && containerId && workspaceId)
	const statusFetcher = (url: string) => gtmFetcher({ url, schema })
	const { data, mutate, error } = useSWR<StatusData>(
		shouldFetch
			? `${GTM_API_LINK}/accounts/${accountId}/containers/${containerId}/workspaces/${workspaceId}/status`
			: null,
		statusFetcher,
		{
			...options,
			revalidateIfStale: false,
			onErrorRetry(_error, key, config, revalidate, revalidateOpts) {
				gtmSWRErrorHandler(_error, revalidate, revalidateOpts)
			},
		},
	)

	useGTMFetchErrorHandling(error)

	return {
		workspaceStatus: data,
		mutateWorkspaceStatus: mutate,
	}
}
